import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Switch,
  Button,
  Box,
  Typography,
  Grid,
  Paper,
  Modal,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import zomato from "../../../../../assets/images/zomato.png";
import swiggy from "../../../../../assets/images/swiggy.png";
import uberEats from "../../../../../assets/images/uberEats.jpg";
import { PosCustomButton } from "../../../../../customComponents/PosCustomButton/PosCustomButton";

const PauseOnlineOrdersModal = ({ open, onClose }) => {
  const [services, setServices] = useState([
    {
      id: 1,
      name: "Zomato",
      logo: zomato,
      percentage: 40,
      trend: "up",
      isPaused: false,
      color: "#E23744",
    },
    {
      id: 2,
      name: "Swiggy",
      logo: swiggy,
      percentage: 40,
      trend: "down",
      isPaused: false,
      color: "#FC8019",
    },
    {
      id: 3,
      name: "Uber Eats",
      logo: uberEats,
      percentage: 40,
      trend: "down",
      isPaused: false,
      color: "#06C167",
    },
  ]);

  const handleToggle = (id) => {
    setServices((prev) =>
      prev.map((service) =>
        service.id === id ? { ...service, isPaused: !service.isPaused } : service
      )
    );
  };

  const handlePauseAll = () => {
    setServices((prev) => prev.map((service) => ({ ...service, isPaused: true })));
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    maxHeight: "90vh",
    overflowY: "auto",
    bgcolor: "#fff",
    border: "1px solid #E6E6E6",
    p: "1.5rem",
    borderRadius: "0.75rem",
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="add-stock-adjust-modal">
      <Box sx={style}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <h3 style={{ margin: 0, fontSize: "1.25rem", fontWeight: 600 }}>Pause Online Orders</h3>
          <CancelIcon
            fontSize="small"
            onClick={onClose}
            sx={{ cursor: "pointer", color: "#666" }}
          />
        </div>

        <div sx={{ pt: 3, pb: 2 }}>
          <Grid container spacing={2}>
            {services?.map((service) => (
              <Grid item xs={6} sm={6} md={3} key={service.id}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    border: "1px solid #e0e0e0",
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    bgcolor: service?.isPaused ? "#f5f5f5" : "white",
                    transition: "all 0.3s ease",
                  }}
                >
                  {/* Service Logo and Name */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Box
                      sx={{
                        width: 26,
                        height: 26,
                        borderRadius: 1,
                        bgcolor: service?.color,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "18px",
                      }}
                    >
                      <img
                        src={service?.logo}
                        style={{ width: "26px", height: "26px", borderRadius: "4px" }}
                      />
                    </Box>
                    <Typography variant="body2" fontWeight={600} sx={{ color: "text.primary" }}>
                      {service?.name}
                    </Typography>
                  </Box>

                  {/* Percentage and Trend */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      <Typography variant="body2" fontWeight={500} sx={{ color: "text.secondary" }}>
                        {service?.percentage}%
                      </Typography>
                      {service?.trend === "up" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 16, color: "success.main" }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 16, color: "error.main" }} />
                      )}
                    </Box>

                    {/* Toggle Switch */}
                    <Switch
                      checked={service?.isPaused}
                      onChange={() => handleToggle(service?.id)}
                      size="small"
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: service?.color,
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                          backgroundColor: service?.color,
                        },
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>

          {/* Pause All Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              mt: 3,
            }}
          >
            <PosCustomButton
              title="Pause All"
              variant="red-transparent"
              radius="4px"
              p={"8px 10px"}
              onClickFunction={handlePauseAll}
            />
          </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default PauseOnlineOrdersModal;
